/* Azar Group — INGCO offer deck behaviour (September 2026)

   Three jobs:
   1. Run the shared countdown. The end date is read from the markup, so moving
      it in the theme editor moves every slide's clock. When time runs out the
      deck removes itself; the Liquid date gate keeps it away on the next load.
   2. Page between offers: arrows, progress segments, swipe and arrow keys, with
      autoplay that pauses while the shopper hovers, focuses or leaves the tab.
   3. "Add offer to cart" adds the kit and its free lines in one request. */

(function () {
  document.querySelectorAll('[data-azar-band]').forEach(init);

  function two(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(deck) {
    if (deck.dataset.azarInit === 'true') return;
    deck.dataset.azarInit = 'true';

    /* ---- countdown ---- */

    var end = Date.parse(deck.getAttribute('data-ends'));
    var cells = deck.querySelectorAll('[data-unit]');
    var clock = null;

    function tick() {
      if (isNaN(end)) return;
      var left = end - Date.now();
      if (left <= 0) {
        clearInterval(clock);
        (deck.closest('.azar-band-outer') || deck).remove();
        return;
      }
      var values = {
        days: Math.floor(left / 864e5),
        hrs: Math.floor(left / 36e5) % 24,
        min: Math.floor(left / 6e4) % 60,
        sec: Math.floor(left / 1e3) % 60
      };
      cells.forEach(function (el) {
        var v = values[el.getAttribute('data-unit')];
        if (v !== undefined) el.textContent = two(v);
      });
    }

    tick();
    clock = setInterval(tick, 1000);

    /* ---- pager ---- */

    var slides = Array.prototype.slice.call(deck.querySelectorAll('[data-azar-slide]'));
    var segs = Array.prototype.slice.call(deck.querySelectorAll('[data-azar-seg]'));
    var counter = deck.querySelector('[data-azar-current]');
    var info = Array.prototype.slice.call(
      (deck.closest('.azar-band-outer') || deck).querySelectorAll('[data-azar-info]')
    );
    var dwell = parseInt(deck.getAttribute('data-dwell'), 10) || 8000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var auto = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !on;
      });
      segs.forEach(function (seg, n) {
        seg.classList.toggle('is-active', n === index);
        seg.classList.toggle('is-done', n < index);
        seg.setAttribute('aria-current', n === index ? 'true' : 'false');
        /* Restart the progress fill for the new slide. */
        var fill = seg.querySelector('.azar-band-deck__fill');
        if (fill) {
          fill.style.animation = 'none';
          void fill.offsetWidth;
          fill.style.animation = '';
        }
      });
      if (counter) counter.textContent = two(index + 1);
      /* Terms and "how it works" copy outside the deck follow the active offer. */
      info.forEach(function (el) {
        el.hidden = el.getAttribute('data-azar-info') !== String(index);
      });
    }

    function stop() {
      if (auto) clearTimeout(auto);
      auto = null;
      deck.classList.remove('is-playing');
    }

    function play() {
      stop();
      if (reduced || slides.length < 2) return;
      deck.classList.add('is-playing');
      show(index);
      auto = setTimeout(function () {
        index = (index + 1) % slides.length;
        play();
      }, dwell);
    }

    function go(i) {
      show(i);
      play();
    }

    if (slides.length > 1) {
      var prev = deck.querySelector('[data-azar-prev]');
      var next = deck.querySelector('[data-azar-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      segs.forEach(function (seg) {
        seg.addEventListener('click', function () { go(parseInt(seg.getAttribute('data-azar-seg'), 10)); });
      });

      deck.addEventListener('mouseenter', stop);
      deck.addEventListener('mouseleave', play);
      deck.addEventListener('focusin', stop);
      deck.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!deck.contains(document.activeElement)) play();
        }, 0);
      });
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : play();
      });

      deck.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(index - 1);
        if (e.key === 'ArrowRight') go(index + 1);
      });

      var startX = null;
      var startY = null;
      deck.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      deck.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
      }, { passive: true });

      show(0);
      play();
    }

    /* ---- add the offer lines ---- */

    deck.querySelectorAll('[data-azar-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = btn.closest('[data-azar-slide]');
        if (!slide) return;
        var kitId = slide.getAttribute('data-kit-id');
        var giftId = slide.getAttribute('data-gift-id');
        var qty = parseInt(slide.getAttribute('data-gift-qty'), 10) || 1;
        var buyQty = parseInt(slide.getAttribute('data-buy-qty'), 10) || 1;
        if (!kitId) return;

        var items = [];
        if (!giftId) {
          /* No checkout discount for this offer: add the kit only. */
          items.push({ id: Number(kitId), quantity: buyQty });
        } else if (kitId === giftId) {
          items.push({ id: Number(kitId), quantity: buyQty + qty });
        } else {
          items.push({ id: Number(kitId), quantity: buyQty });
          items.push({ id: Number(giftId), quantity: qty });
        }

        /* A second free item, when the offer carries one. */
        var bonusId = slide.getAttribute('data-bonus-id');
        var bonusQty = parseInt(slide.getAttribute('data-bonus-qty'), 10) || 1;
        if (bonusId) {
          items.push({ id: Number(bonusId), quantity: bonusQty });
        }

        var label = btn.textContent;
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            /* Send them to the kit's page rather than leaving a dead button. */
            btn.disabled = false;
            btn.textContent = label;
            window.location.href = '/products/' + (slide.getAttribute('data-kit-handle') || '');
          });
      });
    });
  }
})();
